var _tspan, _tspan2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "297mm",
    height: "210mm",
    viewBox: "0 0 1122.5 793.7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Quicksand",
    fontSize: "40px",
    style: {
      lineHeight: 1.25,
      shapeInside: "url(#rect201508)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("text", {
    x: 135.69821,
    y: 319.1972,
    fontFamily: "Quicksand",
    fontSize: "234.67px",
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 135.69821,
    y: 319.1972,
    fill: "#000000",
    fontFamily: "'Fira Sans'",
    fontSize: "234.67px"
  }, "DEEP"))), /*#__PURE__*/React.createElement("text", {
    x: 391.29572,
    y: 506.68723,
    fontFamily: "Quicksand",
    fontSize: "235.66px",
    strokeWidth: 1.1783,
    style: {
      lineHeight: 1.25
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 391.29572,
    y: 506.68723,
    fill: "#000000",
    fontFamily: "'Fira Sans'",
    fontSize: "235.66px",
    strokeWidth: 1.1783
  }, "ERTIC"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m157.86 353.71c101.76 0 102.25-0.0639 102.25-0.0639l60.889 143.08 60.107-143.41 150.74 0.1013",
    fill: "none",
    stroke: "#f00",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 18.217
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.71738e659c3cde59c83d2050fdf1d8f7.svg";
export { ForwardRef as ReactComponent };